Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default=function(ctx) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }


    const uniqueId = Date.now();
    const defFreq = ctx.data.frequencyamounts ? ctx.data.frequencyamounts.frequency : 'once';
;
__p += '\n\n<div class="gm-paymentmethod">\n    ';

    ['ideal', 'directdebit', 'paypal', 'creditcard'].forEach(meth => {
        let method = ctx.component[meth]

        if (!method) return;
        const checked = ('paymentmethods' in ctx.data && 'paymentmethod' in ctx.data.paymentmethods) ? 
            ctx.data.paymentmethods.paymentmethod : 
            ctx.component[`default_paymentmethod_${defFreq}`];
     ;
__p += '\n        <input \n            type="radio"\n            name="' +
((__t = ( !ctx.builder ? 'data[paymentmethod]' : 'data[paymentmethod]' + 'builder')) == null ? '' : __t) +
'" \n            value="' +
((__t = ( meth )) == null ? '' : __t) +
'"  \n            id="' +
((__t = ( meth + uniqueId )) == null ? '' : __t) +
'" \n            aria-invalid="false"\n            class="state"\n            ';

                if (checked === meth) {
                    ;
__p += '\n            checked="checked"\n                    ';

                } 
            ;
__p += '\n        >\n    ';

        });
    ;
__p += '\n    <div class="gm-paymentmethod-tabbar">\n    ';

    ['ideal', 'directdebit', 'paypal', 'creditcard'].forEach(meth => {
        let method = ctx.component[meth]

        if (!method) return;

        let label = ctx.component[`${meth}_label`]
    ;
__p += '\n        <label \n            for="' +
((__t = ( meth + uniqueId )) == null ? '' : __t) +
'" \n            id="' +
((__t = ( meth + '-label' + uniqueId )) == null ? '' : __t) +
'" \n            class="' +
((__t = ( `gm-paymentmethod-tabbar-tab ${meth}-label` )) == null ? '' : __t) +
'"\n            ';
                    
              if (!ctx.component[meth+'_'+defFreq]) {
            ;
__p += '\n            style="display:none;"\n            ';

                } 
            ;
__p += '\n        >\n            ' +
((__t = ( ctx.t(label) )) == null ? '' : __t) +
'\n        </label>\n    ';

        });
    ;
__p += '\n    </div>\n\n    <div class="gm-paymentmethod-container">\n        ';

        ['ideal', 'directdebit', 'paypal', 'creditcard'].forEach(meth => {
            let method = ctx.component[meth]

            if (!method) return;

            const defaultMethod = ctx.component[`default_paymentmethod_${defFreq}`]
        ;
__p += '\n        <div id="' +
((__t = ( meth + '-panel' )) == null ? '' : __t) +
'" class="gm-paymentmethod-content">\n            ';
 
                if (meth === 'ideal') {    
            ;
__p += '\n                <div \n                    ref="component"\n                    class="form-group has-feedback formio-component formio-component-textfield formio-component-bank required"\n                    id="' +
((__t = ( 'bank-container' + uniqueId )) == null ? '' : __t) +
'" \n                >\n                    ';

                        if (ctx.component.bank_label){
                    ;
__p += '\n                    <label id="l-bank-bank" for="' +
((__t = ( 'bank-bank' + uniqueId )) == null ? '' : __t) +
'" class="col-form-label field-required" ref="label">\n                        ' +
((__t = ( ctx.t(ctx.component.bank_label) )) == null ? '' : __t) +
'\n                    </label>\n                    ';

                        }        
                    ;
__p += '\n                        <select \n                            class="gm-fancyinput form-control"\n                            id="bank"\n                            name="' +
((__t = ( !ctx.builder ? 'data[bank]' : 'data[bank]' + 'builder')) == null ? '' : __t) +
'"\n                            rows="10" \n                            cols="40" >\n                            <option value="">' +
((__t = ( ctx.t('Selecteer je bank') )) == null ? '' : __t) +
'</option>\n            ';

                    
                    for (let bank of ctx.component.banks || []) {
            ;
__p += '\n                            <option\n                            ';
 if (ctx.data.paymentmethods && 'bank' in ctx.data.paymentmethods && ctx.data.paymentmethods.bank === bank.value) { ;
__p += ' \n                                selected="selected" \n                            ';
 } ;
__p += '\n                              value="' +
((__t = (bank.value)) == null ? '' : __t) +
'"\n                            >\n                              ' +
((__t = ( ctx.t(bank.label) )) == null ? '' : __t) +
'\n                            </option>\n            ';

                    }
            ;
__p += '    \n                        </select>\n                </div>\n            ';

                }

                if (meth === 'directdebit') {
            ;
__p += '\n                <div \n                    ref="component"\n                    class="form-group has-feedback formio-component formio-component-textfield formio-component-iban required"\n                    id="' +
((__t = ( 'iban-container' + uniqueId )) == null ? '' : __t) +
'" \n                >\n                ';

                    if (ctx.component.iban_label) {
                ;
__p += '\n                    <label id="l-iban-iban" for="' +
((__t = ( 'iban-iban' + uniqueId )) == null ? '' : __t) +
'" class="col-form-label field-required" ref="label">\n                        ' +
((__t = ( ctx.t(ctx.component.iban_label) )) == null ? '' : __t) +
'\n                    </label>\n                ';

                    }        
                ;
__p += '\n                    <div ref="component"\n                        class="form-group has-feedback formio-component formio-component-textfield formio-component-iban required"\n                    > \n                        <div class="input-group">\n                            <input\n                                aria-required="true" \n                                aria-labelledby="l-iban-iban"\n                                id="' +
((__t = ( 'iban-iban' + uniqueId )) == null ? '' : __t) +
'" \n                                type="text"\n                                name="' +
((__t = ( !ctx.builder ? 'data[iban]' : 'data[iban]' + 'builder')) == null ? '' : __t) +
'"\n                                ';
 if (ctx.data.paymentmethods && 'iban' in ctx.data.paymentmethods) { ;
__p += ' \n                                    value="' +
((__t = ( ctx.data.paymentmethods.iban )) == null ? '' : __t) +
'" \n                                ';
 } ;
__p += '\n                                class="js_fancy_input fancy_input form-control gm-fancyinput" \n                                maxlength="32"\n                                placeholder="IBAN *" >\n                            ';

                                if (ctx.t(ctx.component.iban_suffix)) {
                            ;
__p += '\n                            <div ref="suffix" class="input-group-append">\n                                <span class="input-group-text">\n                                    ' +
((__t = ( ctx.t(ctx.component.iban_suffix) )) == null ? '' : __t) +
'\n                                </span>\n                            </div>\n                            ';

                                }        
                            ;
__p += '\n                        </div>\n                    </div>\n                </div>\n                <div \n                    ref="component"\n                    class="form-group has-feedback formio-component formio-component-textfield formio-component-bic required"\n                    id="' +
((__t = ( 'bic-container' + uniqueId )) == null ? '' : __t) +
'" \n                    style="display: none;"\n                >\n                ';

                    if (ctx.component.bic_label) {
                ;
__p += '\n                    <label id="l-bic-bic" for="' +
((__t = ( 'bic-bic' + uniqueId )) == null ? '' : __t) +
'" class="col-form-label field-required" ref="label">\n                        ' +
((__t = ( ctx.t(ctx.component.bic_label) )) == null ? '' : __t) +
'\n                    </label>\n                ';

                    }
                ;
__p += '\n                    <div ref="element">\n                        <div class="input-group">                        \n                            <input \n                                aria-required="true" \n                                aria-labelledby="l-bic-bic"\n                                id="' +
((__t = ( 'bic-bic' + uniqueId )) == null ? '' : __t) +
'" \n                                type="text" \n                                name="' +
((__t = ( !ctx.builder ? 'data[bic]' : 'data[bic]' + 'builder')) == null ? '' : __t) +
'"\n                                ';
 if (ctx.data.paymentmethods && 'bic' in ctx.data.paymentmethods) { ;
__p += ' \n                                    value="' +
((__t = ( ctx.data.paymentmethods.bic )) == null ? '' : __t) +
'" \n                                ';
 } ;
__p += '\n                                class="js_fancy_input fancy_input form-control gm-fancyinput" \n                                maxlength="11"\n                                placeholder="BIC"\n                            >\n                            ';

                                if (ctx.component.bic_suffix) {
                            ;
__p += '\n                            <div ref="suffix" class="input-group-append">\n                                <span class="input-group-text">\n                                    ' +
((__t = ( ctx.t(ctx.component.bic_suffix) )) == null ? '' : __t) +
'\n                                </span>\n                            </div>\n                            ';

                                }        
                            ;
__p += '\n                        </div>\n                    </div>\n                </div>\n\n                ';

                    if (ctx.component.directdebit_description) {
                ;
__p += '\n                <small id="creditdebit-text">\n                  ' +
((__t = ( ctx.t(ctx.component.directdebit_description) )) == null ? '' : __t) +
'\n                </small>\n                ';

                    }
                }
                if (meth === 'paypal') {    
            ;
__p += '\n                <p>' +
((__t = ( ctx.t(ctx.component.paypal_description) )) == null ? '' : __t) +
'</p>  \n            ';

                }
                if (meth === 'creditcard') {
                    ctx.component[meth]
            ;
__p += '\n                <div class="gm-paymentmethod-cc gm-radio-buttons" id="creditoptions_formfield">\n            ';

                    for (let option of ctx.component.creditoptions) {
            ;
__p += '\n                <input \n                    type="radio"\n                    name="' +
((__t = ( !ctx.builder ? 'data[creditoptions]' : 'data[creditoptions]' + 'builder')) == null ? '' : __t) +
'" \n                    value="' +
((__t = (option.value)) == null ? '' : __t) +
'" \n                    ';
 if (ctx.data.paymentmethods && 'creditoptions' in ctx.data.paymentmethods) { ;
__p += ' \n                      checked="checked"\n                    ';
 } ;
__p += '\n                    id="' +
((__t = ('creditoptions_' + option.value + uniqueId )) == null ? '' : __t) +
'" \n                >\n                <label for="' +
((__t = ('creditoptions_' + option.value + uniqueId )) == null ? '' : __t) +
'" >\n                    <img class="payment-logo" src="' +
((__t = (option.logo)) == null ? '' : __t) +
'" alt="' +
((__t = (option.name)) == null ? '' : __t) +
'">\n                </label>\n            ';

                    }
            ;
__p += '\n                    </div>\n            ';

                }
            ;
__p += '\n        </div>\n        ';

            });
        ;
__p += '\n    </div>\n</div>\n';

    $(function() {
        const getName = (name) => {
            return ctx.builder ? name + 'builder': name;
        };

        const $bicContainer = $('#bic-container' + uniqueId);
        const $iban = $(`input[name="${getName('data[iban]')}"]`);

        const toggleBic = (display = true) => {
            if (display) {
                $bicContainer.slideDown();
            } else {
                $bicContainer.slideUp();
            }
        };

        // hander function for the iban field
        const ibanBlurHandler = function (event) {
          const value = $(this).val();

          // if the iban value is set and its not a dutch iban, show the bic field
          if (value == "" || value.toLowerCase().substring(0,2) == 'nl') {
            toggleBic(false);
          } else { 
            toggleBic(true);
          };
        };

        $iban.on('blur', ibanBlurHandler);

        let frequencyChangeHandler = () => {
            let freq = $('input[name="'+getName('data[frequency]')+'"]:checked').val() || defFreq;

            const defaultMeth = ('paymentmethods' in ctx.data && 'paymentmethod' in ctx.data.paymentmethods) ? 
              ctx.data.paymentmethods.paymentmethod : 
              ctx.component[`default_paymentmethod_${freq}`];

            // for loop
            const meths = ["ideal", "directdebit", "paypal", "creditcard"];
            
            meths.forEach((meth) => {
                let $methodLabel = $(`#${meth}-label${uniqueId}`);

                // set default method for this freq
                if (defaultMeth === meth) {
                  $(`#${meth + uniqueId}`).prop('checked', true);
                } else {
                  $(`#${meth + uniqueId}`).prop('checked', false);
                }

                // show or hide label
                if (ctx.component[`${meth}_${freq}`]) {
                  $methodLabel.show();
                } else {
                  $methodLabel.hide()
                }
            });  
            
            // if no defaultmethod
            const paymentmethod = $('input[name="'+getName('data[paymentmethod]')+'"]:checked').val();

            if (!ctx.component[`${paymentmethod}_${freq}`]) {
                for (let meth of meths) {
                    if (ctx.component[meth+'_'+freq]) {
                      $(`input[value="${meth}"]`).prop('checked', true);

                      return;
                    }
                }
            }

            // If we're switching between freq reset the values
            setValue();
        };
        
        $('input[name="'+getName('data[frequency]')+'"]').change(frequencyChangeHandler);

        $(ctx.instance.element).find('input, select').change(() => {
            setValue();
        });

        const setValue = () => {
          let paymentmethod = $('input[name="data[paymentmethod]"]:checked').val();
          let bankValue = $('select[name="data[bank]"]').val();
          let ibanValue = $('input[name="data[iban]"]').val();
          let bicValue = $('input[name="data[bic]"]').val();
          let ccValue = $('input[name="data[creditoptions]"]:checked').val();

          switch (paymentmethod) {
            case 'directdebit':
                ctx.setValue({
                  paymentmethod,
                  iban: ibanValue,
                  bic: bicValue
                });
                break;
            case 'ideal':
                ctx.setValue({
                  paymentmethod,
                  bank: bankValue,
                });
                break;
            case 'paypal':
                ctx.setValue({
                  paymentmethod,
                });
                break;
            case 'creditcard':
                ctx.setValue({
                  paymentmethod,
                  creditoptions: ccValue
                });
                break;
            default:
                break;
          }

          // Remove all unrelated values
          resetValues(paymentmethod);
        }

        const resetValues = (paymentmethod = 'all') => {
          // Reset all the input values
          const paymentMethods = {
            directdebit: ['input[name="data[iban]"]', 'input[name="data[bic]"]'],
            ideal: ['select[name="data[bank]"]'],
            paypal: [],
            creditcard: ['input[name="data[creditoptions]"]:checked'],
          }

          for (const method in paymentMethods) {
            if (method === paymentmethod) continue;

            paymentMethods[method].forEach(item => {
                const elem = document.querySelector(item)

                if (!elem) return;

                // Validate if we need to uncheck
                if (/:checked$/.test(item)) {
                  elem.checked = false
                } else {
                  elem.value = ''
                }
            })
          }
        }

        // Set initial values
        frequencyChangeHandler();
});
;
__p += '\n';
return __p
}